import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

export interface CareersListAlertProps {
  readonly message: MessageKey;
}

const CareersListAlert = ({ message }: CareersListAlertProps) => {
  const t = useTranslations();

  return (
    <div className="flex justify-center py-24">
      <TypographyV3 variant="body-small">{t(message)}</TypographyV3>
    </div>
  );
};

export default CareersListAlert;
